import { action, makeObservable, observable } from 'mobx';
import * as utils from '../../helpers/utils';

class CannedMessage {
  _id;

  @observable Text;

  @observable CannedMessageType;

  @observable IsDeleted;

  @observable CreationDate;

  constructor(incObject, store) {
    makeObservable(this);

    this._id = incObject._id ? incObject._id : utils.generateGuid();
    this.Text = incObject.Text || null;
    this.CannedMessageType =
      store.cannedMessageTypeStore.UpsertAndGet(incObject.CannedMessageType) || null;
    this.IsDeleted = incObject.IsDeleted || false;
    this.CreationDate = incObject.CreationDate || null;
  }

  /* eslint-disable */
  @action static UpdateObject(incObject, oldObject, rootStore) {
    if (incObject.IsDeleted) {
      rootStore.cannedMessageStore.cannedMessages = rootStore.cannedMessageStore.cannedMessages.filter(
        (f) => f._id !== incObject._id
      );
      return null;
    }

    oldObject.Text = incObject.Text;
    oldObject.CannedMessageType = rootStore.cannedMessageTypeStore.UpsertAndGet(
      incObject.CannedMessageType
    );
    oldObject.IsDeleted = incObject.IsDeleted;
    oldObject.CreationDate = incObject.CreationDate;
    return oldObject;
  }
  /* eslint-enable */
}

export default CannedMessage;
